import type { ReactNode } from "react";

import { Button, Modal } from "@/components/common";

type Props = {
  title: ReactNode;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: "primary" | "danger";
  loading?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onClose: () => void;
};

/** Diálogo de confirmação alinhado ao design system (substitui window.confirm nativo). */
export function ConfirmDialog({
  title,
  message,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  variant = "danger",
  loading = false,
  error = null,
  onConfirm,
  onClose,
}: Props) {
  return (
    <Modal
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={variant} onClick={onConfirm} disabled={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p className="td-small">{message}</p>
      {error && (
        <div className="form-error" role="alert" style={{ marginTop: 8 }}>
          {error}
        </div>
      )}
    </Modal>
  );
}
